/* dt-geo-price.js — show course fees in the visitor's local currency.
   Display only: checkout still charges the INR price (store is INR-only, no Shopify Payments in India).
   Straight conversion of the INR amount at the fixed rates below (INR -> X, 29 Sep 2026, open.er-api.com).
   Test from India: add ?dt_country=US (or JP, MY, GB, DE ...) to any URL; ?dt_country=IN resets. */
(function () {
  "use strict";
  if (window.__dtGeo) return;
  window.__dtGeo = 1;
  var D = document;

  var RATES_DATE = "29 Sep 2026";
  var R = {
    USD: 0.010409, EUR: 0.009163, GBP: 0.00786, CAD: 0.014764, AUD: 0.014833, NZD: 0.018371,
    MYR: 0.042537, JPY: 1.6384, TWD: 0.330914, SGD: 0.013315, HKD: 0.081743, KRW: 14.147062,
    PHP: 0.650327, THB: 0.349755, IDR: 187.100966, AED: 0.038227, SAR: 0.039034, QAR: 0.037889,
    KWD: 0.003214, OMR: 0.004002, BHD: 0.003914, CHF: 0.008668, NOK: 0.099196, ZAR: 0.171002,
    LKR: 3.451066, NPR: 1.6, BDT: 1.282171, PKR: 2.885129
  };
  var SYM = {
    USD: "$", EUR: "€", GBP: "\xA3", CAD: "C$", AUD: "A$", NZD: "NZ$", MYR: "RM", JPY: "\xA5",
    TWD: "NT$", SGD: "S$", HKD: "HK$", KRW: "₩", PHP: "₱", THB: "฿", IDR: "Rp\xA0",
    AED: "AED\xA0", SAR: "SAR\xA0", QAR: "QAR\xA0", KWD: "KWD\xA0", OMR: "OMR\xA0", BHD: "BHD\xA0",
    CHF: "CHF\xA0", NOK: "NOK\xA0", ZAR: "R\xA0", LKR: "LKR\xA0", NPR: "NPR\xA0", BDT: "৳", PKR: "PKR\xA0"
  };
  var NAME = {
    USD: "US dollars", EUR: "euros", GBP: "British pounds", CAD: "Canadian dollars",
    AUD: "Australian dollars", NZD: "New Zealand dollars", MYR: "Malaysian ringgit", JPY: "Japanese yen",
    TWD: "New Taiwan dollars", SGD: "Singapore dollars", HKD: "Hong Kong dollars", KRW: "Korean won",
    PHP: "Philippine pesos", THB: "Thai baht", IDR: "Indonesian rupiah", AED: "UAE dirhams",
    SAR: "Saudi riyals", QAR: "Qatari riyals", KWD: "Kuwaiti dinars", OMR: "Omani rials",
    BHD: "Bahraini dinars", CHF: "Swiss francs", NOK: "Norwegian kroner", ZAR: "South African rand",
    LKR: "Sri Lankan rupees", NPR: "Nepalese rupees", BDT: "Bangladeshi taka", PKR: "Pakistani rupees"
  };
  // EU members + euro micro-states all get EUR; everything unlisted (outside India) gets USD.
  var EURO = "AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE AD MC SM VA ME XK".split(" ");
  var CUR = {
    GB: "GBP", IM: "GBP", JE: "GBP", GG: "GBP", CA: "CAD", AU: "AUD", NZ: "NZD", MY: "MYR", JP: "JPY",
    TW: "TWD", SG: "SGD", HK: "HKD", KR: "KRW", PH: "PHP", TH: "THB", ID: "IDR", AE: "AED", SA: "SAR",
    QA: "QAR", KW: "KWD", OM: "OMR", BH: "BHD", CH: "CHF", LI: "CHF", NO: "NOK", ZA: "ZAR", LK: "LKR",
    NP: "NPR", BD: "BDT", PK: "PKR"
  };
  // Course fees and strike-through prices; these convert anywhere on the page.
  // Any other rupee amount converts only inside a price / fee / total / cart element.
  var FEES = { 5000: 1, 12999: 1, 16249: 1, 24999: 1, 25000: 1, 27999: 1, 29999: 1, 31249: 1, 31250: 1, 37499: 1, 38000: 1, 40000: 1, 45000: 1, 50000: 1 };
  var PRICE_BOX = '[class*="price"],[class*="Price"],[class*="fee"],[id*="Fee"],[class*="total"],[class*="Total"],' +
    '[id*="Price"],[id*="Total"],[class*="cart"],[id*="cart"],[id*="Cart"],cart-drawer,cart-items,cart-notification';

  var ss = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  var q = location.search.match(/[?&]dt_country=([A-Za-z]{2})/);
  if (q) ss.set("dtCC", q[1].toUpperCase());

  function country() {
    var c = ss.get("dtCC");
    if (c !== null && c !== "") return Promise.resolve(c);
    return fetch("/browsing_context_suggestions.json", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var cc = (j.detected_values && j.detected_values.country && j.detected_values.country.handle) || "";
        ss.set("dtCC", cc);
        return cc;
      })
      .catch(function () { return ""; });
  }

  function currencyFor(cc) {
    if (!cc || cc === "IN") return null;
    return EURO.indexOf(cc) >= 0 ? "EUR" : CUR[cc] || "USD";
  }

  country().then(function (cc) {
    var cur = currencyFor(cc);
    if (cur) start(cur);
  });

  function start(cur) {
    D.documentElement.setAttribute("data-dt-currency", cur);
    var rate = R[cur];

    function convert(inr) {
      var v = inr * rate;
      var step = v >= 100000 ? 1000 : v >= 10000 ? 100 : v >= 1000 ? 10 : 1;
      return SYM[cur] + (Math.round(v / step) * step).toLocaleString("en-US");
    }

    var RX = /(₹|Rs\.?|INR)\s?((?:\d{1,2},)?(?:\d{1,3},)*\d{3}|\d{4,7})(?:\.00)?(?:\/-)?/g;
    var SALARY = /^\s*(?:-|–|to)?\s*(?:\d[\d,.]*\s*)?(LPA|lakh|lac|L\b|cr\b|crore|k\b|\/\s*(?:mo|month|yr|year|hr|hour)|per\s|a\s+month|monthly|p\.?a\.?|salary|stipend)/i;
    var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, CODE: 1, PRE: 1, OPTION: 1 };

    function fix(node) {
      var s = node.nodeValue;
      if (!s || s.length < 4 || !/₹|Rs|INR/.test(s)) return;
      var p = node.parentNode;
      if (!p || SKIP[p.nodeName] || (p.closest && p.closest("[data-dt-geo-skip],script,style,code,pre"))) return;
      var inBox = !!(p.closest && p.closest(PRICE_BOX));
      var out = s.replace(RX, function (m, sym, num, off) {
        var n = +num.replace(/,/g, "");
        if (n < 100 || (!FEES[n] && !inBox)) return m;
        if (SALARY.test(s.slice(off + m.length, off + m.length + 24))) return m;
        return convert(n);
      });
      if (out !== s) node.nodeValue = out;
    }

    function walk(root) {
      if (!root) return;
      if (root.nodeType === 3) return fix(root);
      if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
      for (var w = D.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n; (n = w.nextNode()); ) fix(n);
    }

    function note(root) {
      var scope = root.querySelectorAll ? root : D;
      var btns = [].slice.call(scope.querySelectorAll('[name="checkout"], #cpEnrollBtn, [data-dt-geo-note]'));
      var main = D.querySelector('main form[action*="/cart/add"] [name="add"], main form[action*="/cart/add"] .product-form__submit');
      if (main && btns.indexOf(main) < 0) btns.push(main);
      for (var i = 0; i < btns.length; i++) {
        var box = btns[i].parentNode;
        if (!box || box.querySelector(".dt-geo-note")) continue;
        var p = D.createElement("p");
        p.className = "dt-geo-note";
        p.setAttribute("data-dt-geo-skip", "");
        p.style.cssText = "font-size:12px;line-height:1.4;opacity:.75;margin:8px 0 0;text-align:center;width:100%";
        p.textContent = "Prices shown in " + NAME[cur] + ", converted from Indian rupees at the " + RATES_DATE +
          " rate. Checkout charges the INR amount and your bank converts it, so the final charge may differ slightly.";
        box.appendChild(p);
      }
    }

    function all(root) { walk(root); note(root); }
    all(D.body);

    var queue = [], timer = 0;
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var r = recs[i];
        if (r.type === "characterData") queue.push(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) queue.push(r.addedNodes[j]);
      }
      if (timer) return;
      timer = setTimeout(function () {
        timer = 0;
        var batch = queue;
        queue = [];
        for (var k = 0; k < batch.length; k++) {
          var n = batch[k];
          if (!n.isConnected) continue;
          if (n.nodeType === 3) fix(n);
          else if (n.nodeType === 1) all(n);
        }
      }, 120);
    }).observe(D.body, { childList: true, subtree: true, characterData: true });
  }
})();
